// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__B0ROz","consentsList":"PatientConsents_consentsList__3khCA","consentsListEmpty":"PatientConsents_consentsListEmpty__INTc7"};